import API from '@/services/API/api'
import {
    arrayToFrontEndFormat,
    objectToFrontEndFormat,
} from '@/services/ObjectFormatter'
import axios from 'axios'

/**
 * 
 * @param {*} authCode Key of supervisor that gives authorization.
 * @param {*} permission Type of permission that they are authorizing.
 */
const authPermission = async function(authCode, permission) {
    try {
        let response = await axios.get(
            API.AUTH_UNIQUE_KEY,
            {
                params: {
                    auth_code: authCode,
                    permission: permission,
                },
            }
        )

        return response.data
    } catch (error) {

        return error.response.data
    }
}

export default { authPermission }